import RecognitionValues from "./RecognitionValues";

interface TabRecognitionProps {
  readonly render?: boolean;
}

export default function TabRecognition(props: TabRecognitionProps) {
  const { render = true } = props;

  if (!render) return null;

  return (
    <div>
      <RecognitionValues />
    </div>
  );
}
